/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_Private_KeyInputs */

const en_admin_settings_fields_wechat_private_key = /** @type {(inputs: Admin_Settings_Fields_Wechat_Private_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merchant Private Key (PEM)`)
};

/**
* | output |
* | --- |
* | "Merchant Private Key (PEM)" |
*
* @param {Admin_Settings_Fields_Wechat_Private_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_private_key = /** @type {((inputs?: Admin_Settings_Fields_Wechat_Private_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_Private_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_wechat_private_key(inputs)
});
export { admin_settings_fields_wechat_private_key as "admin.settings.fields.wechat_private_key" }